import apiClient from "./api";

export async function getAllUsers() {
  try {
    const response = await apiClient.get('/get-all-users'); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return { success: false, message: "No response received", details: error.request };
    } else {
      // Something happened in setting up the request that triggered an Error
      return { success: false, message: "Request setup error", details: error.message };
    }
  }};

  export async function getRoles() {
    try {
      const response = await apiClient.get('/get-roles'); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return { success: false, message: "No response received", details: error.request };
      } else {
        // Something happened in setting up the request that triggered an Error
        return { success: false, message: "Request setup error", details: error.message };
      }
    }};

    export async function updateUser(id, data) {
      try {
        const response = await apiClient.post('/update-user/' + id, data); // Replace with your endpoint
        return response;
      } catch (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          return error.response;
        } else if (error.request) {
          // The request was made but no response was received
          return { success: false, message: "No response received", details: error.request };
        } else {
          // Something happened in setting up the request that triggered an Error
          return { success: false, message: "Request setup error", details: error.message };
        }
      }};

      export async function createUser(data) {
        try {
          const response = await apiClient.post('/create-user/', data); // Replace with your endpoint
          return response;
        } catch (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            return error.response;
          } else if (error.request) {
            // The request was made but no response was received
            return { success: false, message: "No response received", details: error.request };
          } else {
            // Something happened in setting up the request that triggered an Error
            return { success: false, message: "Request setup error", details: error.message };
          }
        }};

        export async function deleteUser(id) {
          try {
            const response = await apiClient.post('/delete-user/' + id, {}); // Replace with your endpoint
            return response;
          } catch (error) {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              return error.response;
            } else if (error.request) {
              // The request was made but no response was received
              return { success: false, message: "No response received", details: error.request };
            } else {
              // Something happened in setting up the request that triggered an Error
              return { success: false, message: "Request setup error", details: error.message };
            }
          }};